import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeForm from '../views/HomeForm.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'HomeForm',
    component: HomeForm
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
